import React from "react";
import CoverBackground from "../../../../assets/img/coverbackground.png";
import PoweredByImage from "../../../../assets/img/newPwdBy.png";
import ReportImage from "../ReportImage";
import { fmtDateTime, isNullOrWhiteSpace } from "../../utils/reportHelpers";

const CoverPage = React.memo(function CoverPage({
  reportData,
  imageProxyBaseUrl,
}) {
  const coverImage =
    reportData?.coverImagesBase64?.CoverBackground ?? CoverBackground;
  const propertyInfo = reportData?.propertyInspectionReport?.propertyInfo;
  const clientLogo =
    reportData?.propertyInspectionReport?.propertyInfo?.clientLogo ?? "";
  const companyDetails = reportData?.propertyInspectionReport?.companyProfile;
  const poweredImage = reportData?.coverImagesBase64?.PoweredBy ?? PoweredByImage;

  const houseimage = propertyInfo?.propertyImage
    ? imageProxyBaseUrl + propertyInfo.propertyImage
    : reportData?.propertyImageBase64
      ? `data:image/jpeg;base64,${reportData.propertyImageBase64}`
      : "";

  let addressContent = "-";
  const companyAddress = companyDetails?.companyAddress ?? "";
  if (companyAddress && !isNullOrWhiteSpace(companyAddress)) {
    const addressParts = companyAddress
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean);
    if (addressParts.length >= 4) {
      addressContent = (
        <>
          {addressParts.slice(0, 2).join(", ")}
          <br />
          {addressParts.slice(2, addressParts.length - 1).join(", ")}
          <br />
          {addressParts[addressParts.length - 1]}
        </>
      );
    } else if (addressParts.length === 3) {
      addressContent = (
        <>
          {addressParts[0]}
          <br />
          {addressParts[1]}
          <br />
          {addressParts[2]}
        </>
      );
    } else if (addressParts.length === 2) {
      addressContent = (
        <>
          {addressParts[0]}
          <br />
          {addressParts[1]}
        </>
      );
    } else {
      addressContent = companyAddress;
    }
  }

  return (
    <div className="page">
      <ReportImage className="background-img" src={coverImage} alt="Background" />
      <div className="content">
        {clientLogo !== "" ? (
          <ReportImage
            className="logo"
            src={imageProxyBaseUrl + clientLogo}
            alt="Client Logo"
          />
        ) : (
          <div className="logo-placeholder" />
        )}
        <h1 className="title">Fire Door Survey</h1>
        <div className="prepared section">
          <div className="section-title">Prepared For</div>
          {propertyInfo?.companyClientName ?? ""}
          <br />
        </div>
        <div className="address section">
          <div className="section-title">Site Address</div>
          {propertyInfo?.propertyName ?? ""}
          <br />
          {propertyInfo?.propertyLocation ?? ""}
        </div>
        <div className="row-box">
          <div className="info-box">
            <div className="info-row">
              <span>Prepared By</span>
              <span>{propertyInfo?.inspectionUpdatedBy ?? ""}</span>
            </div>
            <div className="info-row">
              <span>Surveyed On</span>
              <span>{fmtDateTime(propertyInfo?.inspectionStartedOn)}</span>
            </div>
            <div className="info-row">
              <span>Approved By</span>
              <span>{propertyInfo?.inspectionApprovedBy ?? "-"}</span>
            </div>
            <div className="info-row">
              <span>Approved On</span>
              <span>{fmtDateTime(propertyInfo?.inspectionApprovedDate)}</span>
            </div>
            <div className="info-row">
              <span>Survey Ref</span>
              <span>{propertyInfo?.inspectionReferenceNumber ?? ""}</span>
            </div>
            <div className="info-row">
              <span>Next Survey Due</span>
              <span>{fmtDateTime(propertyInfo?.nextInspectionDueDate)}</span>
            </div>
          </div>
          {houseimage ? (
            <ReportImage className="house-img" src={houseimage} alt="Property photo" />
          ) : (
            <ReportImage className="house-img" src="" alt="Property photo" />
          )}
        </div>
      </div>
      <div className="footer-row">
        <div className="footer-col">
          <div className="footer-title">{companyDetails?.companyName ?? ""}</div>
          <div className="footer-address">{addressContent}</div>
        </div>
        <div className="footer-col">
          <div className="footer-title">&nbsp;</div>
          <div>
            <span className="footer-label">E : </span>
            {companyDetails?.companyEmail ?? ""}
            <br />
            <span className="footer-label">W : </span>
            {companyDetails?.companyWebsite ?? ""}
            <br />
            <span className="footer-label">T : </span>
            {companyDetails?.companyContactNumber ?? ""}
          </div>
        </div>
        <div className="footer-col">
          <ReportImage
            className="powered-logo"
            src={poweredImage}
            alt="Powered By"
          />
        </div>
      </div>
    </div>
  );
});

export default CoverPage;
